
$(document).on("click", ".hk-element-variant", function(e) {
$('.hk-element-variant').removeClass('hk-active');
$(this).addClass('hk-active');
var variant_id = $(this).attr('variant_id');
var selling_plan = $(this).attr('selling_plan');
$('.hk-variant-trigger').hide().removeClass('hk-active');
$('.hk-variant-trigger[variant_id="'+variant_id+'"]').show().addClass('hk-active');
$('.hk-checkout-button').attr('variant_id',variant_id);
$('.hk-checkout-button').attr('selling_plan',selling_plan);
var index = $(this).index();
$('.hk-sub-option-free_gift').removeClass('hk-active');
if (index == 1) {
$('.hk-sub-option-free_gift').eq(0).addClass('hk-active');
}
if (index == 2) {
$('.hk-sub-option-free_gift').eq(0).addClass('hk-active');
$('.hk-sub-option-free_gift').eq(1).addClass('hk-active');
}

var sub_tab = $('.hk-element-sub-option.hk-active').attr('sub_tab');
if (sub_tab == 1) {
$('.hk-checkout-button').attr('selling_plan',selling_plan);
} else {
$('.hk-checkout-button').removeAttr('selling_plan');
}
});



$(document).on("click", ".hk-element-sub-option", function(e) {
$('.hk-element-sub-option').removeClass('hk-active');
$(this).addClass('hk-active');
var sub_tab = $(this).attr('sub_tab');
var selling_plan = $('.hk-element-variant.hk-active').attr('selling_plan');
$('.hk-sub-trigger').hide().removeClass('hk-active');
$('.hk-sub-trigger[sub_tab="'+sub_tab+'"]').show().addClass('hk-active');
if (sub_tab == 1) {
$('.hk-checkout-button').attr('selling_plan',selling_plan);
} else {
$('.hk-checkout-button').removeAttr('selling_plan');
}
});





$(document).on("click", ".hk-question", function (e) {
  if (jQuery(this).hasClass("active")) {
    jQuery(this).toggleClass('active');
    jQuery(this).next().slideToggle();
  } else {
    jQuery('.hk-question').removeClass('active');
    jQuery('.hk-question').next().slideUp();
    jQuery(this).toggleClass('active');
    jQuery(this).next().slideToggle();
  }
});





$(document).on("click", ".hk-element-flavor", function (e) {
var current_img = $(this).find('img').attr('src');
var variant_id = $(this).attr('variant_id1');
var selling_plan = $(this).attr('selling_plan1');
var data_index = $(this).attr('data_index');
var html = '<img src="'+current_img+'" width="auto" height="auto" loading="lazy" fetchpriority="low" alt="flavor">';
$('.hk-variant-trigger.hk-active .hk-selected-variant:not(.hk-active)').eq(0).html(html).addClass('hk-active').attr('variant_id',variant_id).attr('selling_plan',selling_plan).attr('data_index',data_index);

update_variant();
});


$(document).on("click", ".hk-selected-variant.hk-active", function (e) {
$(this).html('').removeClass('hk-active').removeAttr('variant_id').removeAttr('selling_plan').removeAttr('data_index');
update_variant();
});

function update_variant() {
var variant_id1 = null;
var selling_plan1 = null;
var variant_id2 = null;
var selling_plan2 = null;
var variant_id3 = null;
var selling_plan3 = null;


var variant1_length = $('.hk-variant-trigger.hk-active .hk-selected-variant.hk-active[data_index="1"]').length;
if (variant1_length==1){
var variant_id1 = $('.hk-element-flavor[data_index="1"]').attr('variant_id1');
var selling_plan1 = $('.hk-element-flavor[data_index="1"]').attr('selling_plan1');
}
if (variant1_length==2){
var variant_id1 = $('.hk-element-flavor[data_index="1"]').attr('variant_id2');
var selling_plan1 = $('.hk-element-flavor[data_index="1"]').attr('selling_plan2');
}
if (variant1_length==3){
var variant_id1 = $('.hk-element-flavor[data_index="1"]').attr('variant_id3');
var selling_plan1 = $('.hk-element-flavor[data_index="1"]').attr('selling_plan3');
}

var variant2_length = $('.hk-variant-trigger.hk-active .hk-selected-variant.hk-active[data_index="2"]').length;
if (variant2_length==1){
var variant_id2 = $('.hk-element-flavor[data_index="2"]').attr('variant_id1');
var selling_plan2 = $('.hk-element-flavor[data_index="2"]').attr('selling_plan1');
}
if (variant2_length==2){
var variant_id2 = $('.hk-element-flavor[data_index="2"]').attr('variant_id2');
var selling_plan2 = $('.hk-element-flavor[data_index="2"]').attr('selling_plan2');
}
if (variant2_length==3){
var variant_id2 = $('.hk-element-flavor[data_index="2"]').attr('variant_id3');
var selling_plan2 = $('.hk-element-flavor[data_index="2"]').attr('selling_plan3');
}

var variant3_length = $('.hk-variant-trigger.hk-active .hk-selected-variant.hk-active[data_index="3"]').length;
if (variant3_length==1){
var variant_id3 = $('.hk-element-flavor[data_index="3"]').attr('variant_id1');
var selling_plan3 = $('.hk-element-flavor[data_index="3"]').attr('selling_plan1');
}
if (variant3_length==2){
var variant_id3 = $('.hk-element-flavor[data_index="3"]').attr('variant_id2');
var selling_plan3 = $('.hk-element-flavor[data_index="3"]').attr('selling_plan2');
}
if (variant3_length==3){
var variant_id3 = $('.hk-element-flavor[data_index="3"]').attr('variant_id3');
var selling_plan3 = $('.hk-element-flavor[data_index="3"]').attr('selling_plan3');
}
if (variant_id1 != null){
$('.hk-checkout-button').attr('variant_id1',variant_id1);
} else {
$('.hk-checkout-button').removeAttr('variant_id1');
}
if (variant_id2 != null){
$('.hk-checkout-button').attr('variant_id2',variant_id2);
} else {
$('.hk-checkout-button').removeAttr('variant_id2');
}
if (variant_id3 != null){
$('.hk-checkout-button').attr('variant_id3',variant_id3);
} else {
$('.hk-checkout-button').removeAttr('variant_id3');
}
var sub_tab = $('.hk-element-sub-option.hk-active').attr('sub_tab');
if (sub_tab == 1) {
if (variant_id1 != null){
$('.hk-checkout-button').attr('selling_plan1',selling_plan1);
}
if (variant_id2 != null){
$('.hk-checkout-button').attr('selling_plan2',selling_plan2);
}
if (variant_id3 != null){
$('.hk-checkout-button').attr('selling_plan3',selling_plan3);
}
} else {
$('.hk-checkout-button').removeAttr('selling_plan1');
$('.hk-checkout-button').removeAttr('selling_plan2');
$('.hk-checkout-button').removeAttr('selling_plan3');
}



var total = $('.hk-variant-trigger.hk-active .hk-selected-variant').length;
var filled = $('.hk-variant-trigger.hk-active .hk-selected-variant.hk-active').length;
$('.hk-selected-label p strong').text(filled);
$('.hk-selected-label p em').text(total);
if (total == filled) {
$('.hk-selected-label p').addClass('hk-active');
} else {
$('.hk-selected-label p').removeClass('hk-active');
}
var pending = total - filled;
$('.hk-choose-flavors-btn ul li').hide();
$('.hk-choose-flavors-btn ul li:nth-child('+pending+')').show();
}